/** Templates */
import paymentCardDialogTemplate from './paymentCardDialog.html';
/** Styles */
import './paymentCardDialog.scss';

/*******************************************************************************
 * paymentCardDialog Component
 *******************************************************************************/
export const paymentCardDialogComponent = {
  bindings: {
    onLoad: '&',
    billingInfo: '=',
    cartTotal: '<',
    readyForInput: '<'
  },
  template: paymentCardDialogTemplate,
  transclude: { cardInfo: 'cardInfo', submitButton: 'submitButton' },
  controller: controller
};

/*------------*/
/* Controller */
/*------------*/
function controller($scope) {
  var $ctrl = Object.defineProperties(
    Object.assign(this, {
      /*-------------------------*/
      /* Validation error flags. */
      /*-------------------------*/
      errors: {
        addressRequired: false, // All address fields required.
        invalidCardInfo: false, // Some card info fields invalid.
        invalidZipCode: false // Zip Code field invalid.
      },

      /*-------------------------------------------*/
      /* Validated flag set by `validate()`. Turns */
      /* on error status for any invalid fields.   */
      /*-------------------------------------------*/
      validated: false
    }),
    {
      /*--------------------*/
      /* Billing info form. */
      /*--------------------*/
      billingForm: {
        get: function () {
          return $scope.billingForm;
        }
      }
    }
  );

  /*----------------------------------------------------------*/
  /* Prevent dialog from being closed by the user while busy. */
  /*----------------------------------------------------------*/
  $scope.$parent.$on('modal.closing', function (event, reason) {
    if (!$ctrl.readyForInput && reason === 'escape key press')
      event.preventDefault();
  });

  $ctrl.$onInit = function () {
    /*----------------------------------*/
    /* Send validator method to parent. */
    /*----------------------------------*/
    $ctrl.onLoad({
      $validator: function (cardInfoValid) {
        $ctrl.validated = true;

        /*---------------------------------------*/
        /* Show address/card info error messages */
        /* if anything missing or invalid.       */
        /*---------------------------------------*/
        var form = $ctrl.billingForm;
        $ctrl.errors.addressRequired = !!form.$error.required;
        $ctrl.errors.invalidCardInfo = !cardInfoValid;

        /*-------------------------------------*/
        /* Validate zip code. Show error       */
        /* message if not empty and not valid. */
        /*-------------------------------------*/
        form.zipCode.$setValidity(
          'zipCode',
          !!(form.zipCode.$modelValue || '').match(/^\d{5}(-\d{4})?$/)
        );
        $ctrl.errors.invalidZipCode =
          !!form.$error.zipCode && !form.zipCode.$error.required;

        /*-----------------------------------*/
        /* Return `true` if no errors found. */
        /*-----------------------------------*/
        return !Object.keys($ctrl.errors).some(function (key) {
          return !!$ctrl.errors[key];
        });
      }
    });
  };
}
